import { PATH_ANALYTICS, TAB_ANALYTICS } from 'constants/paths';
import { CONTACTS_INNER_ANALYTICS, CONTACT_ANALYTICS } from 'constants/types';
import { getQueryCampaignId, getQueryEmailId } from 'modules/EmailBrowser/utils';
import store from 'store';
import { getQuarterDates, getQueryAccountId, getQueryParam } from 'utils';
import { moveAppliedFiltersToSelected } from '../actions';
import { analyticsDatesFilterChange } from '../Dashboard/actions';
import { getConstantCampaignEmailId } from '../utils';

const DEFAULT_PAGE_LIMIT = 20;
export const CONTACTS_BY_FILTER_ENUM = {
  EQUALS: 1,
  LESS: 2,
  GREATER: 3,
  LESS_OR_EQUAL: 4,
  GREATER_OR_EQUAL: 5,
};

export const getSelectedLabel = (value: string) => {
  switch (value) {
    case 'Unique Opens':
      return 'UNIQUE_OPENS';
    case 'Unique Clicks':
      return 'UNIQUE_CLICKS';
    case 'Total Opens':
      return 'TOTAL_OPENS';
    case 'Total Clicks':
      return 'TOTAL_CLICKS';
  }
};
export const getDisplayLabel = (value: string) => {
  switch (value) {
    case 'UNIQUE_OPENS':
      return 'Unique Opens';
    case 'UNIQUE_CLICKS':
      return 'Unique Clicks';
    case 'TOTAL_OPENS':
      return 'Total Opens';
    case 'TOTAL_CLICKS':
      return 'Total Clicks';
  }
};
export const getSelectedType = (value: string) => {
  switch (value) {
    case '=':
      return 1;
    case '<':
      return 2;
    case '>':
      return 3;
    case '<=':
      return 4;
    case '>=':
      return 5;
  }
};
export const RedirectToContactDetails = (event: any, row: any, history: any, location: any, rowId: string) => {
  moveAppliedFiltersToSelected();
  let queryParams = new URLSearchParams(location.search);
  if (queryParams.get('allCampaigns')) queryParams.delete('allCampaigns');
  if (queryParams.get('fromId_analytics')) queryParams.delete('fromId_analytics');
  const pathname = `${location.pathname}?${queryParams}${rowId !== undefined ? `&fromId_analytics=${rowId}` : ''}`;
  const goBackUrl = window.location.pathname + window.location.search;
  const contact_id = row.contacts_id;
  const selectedPerson = { ...row, contact_id: row.contacts_id };
  delete selectedPerson.contacts_id;
  store.dispatch({
    type: CONTACT_ANALYTICS.SELECTED_PERSON,
    payload: { selectedPerson },
  });
  const urlParts = window.location.pathname.split('/').reverse();
  const tab = urlParts[0] === '' ? urlParts[1] : urlParts[0];
  store.dispatch({ type: CONTACTS_INNER_ANALYTICS.RESET_CONTACT_DETAILS });
  store.dispatch({ type: CONTACT_ANALYTICS.SET_REDIRECT_URL, payload: { redirectUrl: pathname } });
  let url = `/${PATH_ANALYTICS}/${TAB_ANALYTICS.CONTACTS}/dashboard/?contact_id=${
    row.contacts_id !== undefined ? row.contacts_id : row.contact_id
  }`;
  let campaign_id = getQueryParam('campaign_id');
  let email_id = getQueryParam('email_id');
  let workflow_id = getQueryParam('workflow_id');
  let fsId = getQueryParam('fs_id');
  if (campaign_id) {
    url += `&campaign_id=${campaign_id}`;
    if (email_id) url += `&email_id=${email_id}`;
  }
  if (workflow_id) url += `&workflow_id=${workflow_id}`;
  if (fsId) url += `&fs_id=${fsId}`;
  if (!queryParams.get('show_back')) url += `&back_url=${encodeURIComponent(goBackUrl)}`;
  if (event.ctrlKey || event.metaKey) {
    // Ctrl key (or Command key on macOS) is pressed
    // Open the link in a new tab/window
    window.open(url, '_blank');
  } else {
    history(url);
  }
};
export const getPagination = (tab: string, params?: any) => {
  let analyticsDashboard = store.getState().analyticsDashboard;
  let analyticsGraph = store.getState().analyticsGraph;
  let bounceFilter = store.getState().contactAnalytics.bounceFilter;
  const userName = `${store.getState().user.userData.first_name} ${store.getState().user.userData.last_name}`;

  let {
    appliedCampaignIds,
    appliedAssetsIds,
    excludeCampaignsIds,
    appliedExcludeAssetsIds,
    appliedUnselectAllDropdownEmails,
    appliedSelectAllDropdownEmails,
    campaigns,
    appliedSearchedEmailList,
    appliedWorkflowsIds,
  } = analyticsDashboard;
  let { isShareProfile, isDailyIQ, isWeeklyAccountInsights } = analyticsDashboard.appliedCampaignsFilters;
  let { startDate, endDate } = analyticsGraph;

  let campaignIds;
  let emailIds;
  let _params: any = {
    limit: DEFAULT_PAGE_LIMIT,
    tab: tab,
    searchWord: params.searchWord,
    offset: params.offset !== undefined ? params.offset : params.page > 0 ? params.data.length : 0,
    sortBy: params.sortBy,
    sortType: params.sortType,
    selectAll: appliedSelectAllDropdownEmails,
    unSelectAll: appliedUnselectAllDropdownEmails,
    excludeAssetsIds: appliedExcludeAssetsIds,
    allCampaigns: campaigns.length === appliedCampaignIds.length,
    searchedEmailList: appliedSearchedEmailList,
    workflowIds: appliedWorkflowsIds,
    createNewList: params.createNewList,
    listName: params.createNewList ? `${userName} New List ${new Date().toUTCString().replace(',', ' ')}` : '',
  };
  // if (isAllCampaigns) {
  //   _params['allCampaigns'] = true;
  //   _params['excludeCampaignsIds'] = excludeCampaignsIds;
  //   _params['excludeAssetsIds'] = excludeAssetsIds;
  // } else {
  if (appliedCampaignIds.length <= 0 && getQueryCampaignId() > 0)
    campaignIds = appliedCampaignIds.length > 0 ? appliedCampaignIds : [];
  else campaignIds = appliedCampaignIds;
  if (appliedAssetsIds.length <= 0 && getQueryEmailId() > 0)
    emailIds = appliedAssetsIds.length > 0 ? appliedAssetsIds : [];
  else emailIds = appliedAssetsIds;
  _params['emailIds'] = emailIds;
  _params['campaignIds'] = campaignIds;
  if (startDate === '' && endDate === '') {
    analyticsDatesFilterChange({ value: 'qtr', label: '1 QTR' });
    startDate = getQuarterDates().start_date;
    endDate = getQuarterDates().end_date;
    // analyticsDatesFilterChange({ value: "month", label: "Month" });
    // startDate = getMonthDates().start_date;
    // endDate = getMonthDates().end_date;
  }
  _params['startDate'] = startDate;
  _params['endDate'] = endDate;

  if (isShareProfile || isDailyIQ || isWeeklyAccountInsights) {
    let email_campaign_id = getConstantCampaignEmailId({ isShareProfile, isDailyIQ, isWeeklyAccountInsights });
    if (!isShareProfile) _params['emailIds'] = [email_campaign_id];
    _params['campaignIds'] = [email_campaign_id];
  }

  if (params.contactsByFilter) _params['contactsByFilter'] = params.contactsByFilter;
  if (bounceFilter !== '') _params['bounce_filter'] = bounceFilter;
  if (getQueryAccountId()) _params['accountId'] = getQueryAccountId();
  return _params;
};

export const ANALYTICS_DEFAULT_DATES_FILTER = { value: 'qtr', label: '1 QTR' };

// Audit Trail Common Styling
export const commonLinkStyle = `
font-family: 'Roboto';
font-size: 14px;
font-weight: 500;
@media all and (min-width: 1900px) {
  font-size: 18px;
}
  @media all and (max-width: 1439px) {
  font-size: 12px;
}
`;
export const commonStageTextStyle = `
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 500;
  @media all and (min-width: 1900px) {
  font-size: 18px;
}
@media all and (max-width: 1439px) {
  font-size: 12px;
}
`;

export const commonActivityTitleStyle = `
  font-family: 'Roboto';
  font-size: 18px;
  font-weight: 500;
  @media all and (min-width: 1900px) {
  font-size: 22px;
}
  @media all and (max-width: 1439px) {
  font-size: 16px;
}
`;
